import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, round2Decimals } from "../../Components/Items";
import numeroALetra from "../../Components/numeroALetra";
import { formatQRTotal } from "../../Components/RoundQRDecimals";
import { PDF_COLORS, pdfStylesV2, lineLayoutsV2, divisorV2, seccionHeadingV2, PDF_PAGE_MARGINS, pdfFz, applyPdfColors } from "../../Components/PdfComponents/componentsv2.0/stylesPDFv2";
import { PDFHeaderV2 } from "../../Components/PdfComponents/componentsv2.0/PDFHeader";
import { PDFClientInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFClientInfo";
import { PDFCompanyInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFCompanyInfo";
import { PDFItemsTableV2, PDFItemImagesV2 } from "../../Components/PdfComponents/componentsv2.0/PDFItemsTable";
import { PDFSummarySectionV2 } from "../../Components/PdfComponents/componentsv2.0/PDFTotalsSummary";
import { PDFPaymentInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFPaymentInfo";
import { PDFNotesV2 } from "../../Components/PdfComponents/componentsv2.0/PDFNotes";
import { PDFKioskoQRV2, PDFTextoAdicionalV2, PDFBrandFooterConNumeroV2 } from "../../Components/PdfComponents/componentsv2.0/PDFFooter";
import { PDFEquipoMedicoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFEquipoMedico";
import { PDFPagareV2 } from "../../Components/PdfComponents/componentsv2.0/PDFPagare";
import { PDFCartaPorteV2 } from "../../Components/PdfComponents/componentsv2.0/PDFCartaPorte";
import { PDFCfdiFooterV2 } from "../../Components/PdfComponents/componentsv2.0/PDFCfdiFooter";
import { formatearDireccionEntrega } from "../../Components/PdfComponents/formatearDireccionEntrega";
import { BloqueFirmasPdf } from "../../Components/PdfComponents/BloqueFirmasPdf";
// Registra la tipografía Mulish en pdfMake (efecto secundario) y expone su nombre.
import MULISH_FONT from "./mulishFont";
// Registra la variante Mulish SemiBold (600) usada en las etiquetas (efecto secundario).
import "./mulishSemiBoldFont";

moment.locale("es");


const facturaPdfV2 = (values) => {
  const empresa = values.respuestaFactura.empresa;
  const logoBiwo = values.logoBiwo?.base64Completa || values.respuestaFactura?.logoBiwo?.base64Completa;

  applyPdfColors(empresa);

  const dataSat = values.respuestaFactura.dataSat;
  const dataExtra = values.respuestaFactura.data;
  const idKiosko = values.kioskoid;
  const direccionEntrega = values.respuestaFactura?.dataSat?.direccionEntrega || [];
  const numeroRemision = values?.remisionNumero;
  const serieRemision = values?.remisionSerie;
  const mostrarDescUnidad = empresa?.imprimirDesUnidad;
  const decimalesTipoCambioPdf = Number.isFinite(Number(empresa?.decimalesTipoCambioPdf)) ? Number(empresa.decimalesTipoCambioPdf) : 4;
  const decimalesPrecioUnitarioPdf = Number.isFinite(Number(empresa?.decimalesPrecioUnitarioPdf)) ? Number(empresa.decimalesPrecioUnitarioPdf) : 2;
  const decimalesCantidadPdf = Number.isFinite(Number(empresa?.decimalesCantidadPdf)) ? Number(empresa.decimalesCantidadPdf) : 2;
  const formatCantidad = (val) => {
    const num = Number(val);
    if (!Number.isFinite(num)) return val;
    return num.toLocaleString('es-MX', { minimumFractionDigits: decimalesCantidadPdf, maximumFractionDigits: decimalesCantidadPdf });
  };
  // Texto, no arreglo: kvRows esparce cualquier objeto como nodo y con [] la celda queda sin
  // `text` (pdfmake: "Unrecognized document structure"). Las respuestas de agregarVenta,
  // generarFactura, etc. no traen `proyecto`; solo obtenerRespuestaFactura lo arma.
  const proyecto = values.respuestaFactura?.dataSat?.proyecto || "";

  const quitarImpuestosRemisiones = empresa?.quitarImpuestosRemisiones || false;
  const quitarImpuestosFacturas = empresa?.quitarImpuestosFacturas || false;
  const ocultarColumnaIVA = empresa?.ocultarColumnaIVA || false;
  const cantidadJuntoPrecioUnitario = empresa?.cantidadJuntoPrecioUnitario || false;
  // Importe de cada renglón con sus impuestos; "No Desglosar Imp. Facturas" ya los incluye
  const importeConImpuestos = empresa?.importeConImpuestos === true && !quitarImpuestosFacturas;
  const tituloImporte = importeConImpuestos ? "Importe con Impuestos" : "Importe";
  // Columna con el P/U ya descontado, a la derecha del P/U
  const precioUnitarioConDescuento = empresa?.precioUnitarioConDescuento === true;
  const widthPUConDescuento = 9;
  let agregarImpDesc = 0;

  const mostrarClaveSAT = !empresa?.deshabilitarClaveSATCot;
  const mostrarClave = !empresa?.deshabilitarClaveCot;
  const mostrarOC = !empresa?.deshabilitarOCPdf;
  const mostrarFechaEntrega = !empresa?.deshabilitarFechaEntregaPdf;

  const widthClaveSAT = quitarImpuestosRemisiones ? 8 : 9;
  const widthClave = quitarImpuestosRemisiones ? 9 : 12;
  const widthIEPS = 7;
  const widthIVA = 9;

  let widthExtraDescripcion = 0;
  if (!mostrarClaveSAT) widthExtraDescripcion += widthClaveSAT;
  if (!mostrarClave) widthExtraDescripcion += widthClave;
  if (!quitarImpuestosRemisiones && !quitarImpuestosFacturas && !empresa.imprimirIEPS) {
    widthExtraDescripcion += widthIEPS;
  }
  if (!quitarImpuestosRemisiones && ocultarColumnaIVA && !quitarImpuestosFacturas) {
    widthExtraDescripcion += widthIVA;
  }

  const widthExtraCantidad = Math.round(widthExtraDescripcion * 0.05 * 10) / 10;
  const widthExtraUnidad = Math.round(widthExtraDescripcion * 0.15 * 10) / 10;
  const widthExtraClave = mostrarClave ? Math.round(widthExtraDescripcion * 0.15 * 10) / 10 : 0;
  const widthExtraDescripcionFinal = Math.round((widthExtraDescripcion - widthExtraCantidad - widthExtraUnidad - widthExtraClave) * 10) / 10;
  //El flag de remisiones recorta 1% y 3% a Clave SAT y Clave; en la tabla sin
  //impuestos se devuelven a Descripción para que los anchos sumen 100%
  const widthDevueltoClaves = (9 - widthClaveSAT) + (12 - widthClave);

  const agregarEquipoMedico = PDFEquipoMedicoV2({ values, empresa });

  let cartaPorte;
  let complementoComercioExterior;

  if (dataSat?.Complemento?.Any.find(item => item['cartaporte31:CartaPorte'])) {
    cartaPorte = dataSat.Complemento.Any.find(item => item['cartaporte31:CartaPorte'])['cartaporte31:CartaPorte'];
  }
  if (dataSat?.Complemento?.Any.find(item => item['cartaporte30:CartaPorte'])) {
    cartaPorte = dataSat.Complemento.Any.find(item => item['cartaporte30:CartaPorte'])['cartaporte30:CartaPorte'];
  }
  if (dataSat?.Complemento?.Any.find(item => item['cce11:ComercioExterior'])) {
    complementoComercioExterior = dataSat.Complemento.Any.find(item => item['cce11:ComercioExterior'])['cce11:ComercioExterior'];
  }
  if (dataSat?.Complemento?.Any.find(item => item['cce20:ComercioExterior'])) {
    complementoComercioExterior = dataSat.Complemento.Any.find(item => item['cce20:ComercioExterior'])['cce20:ComercioExterior'];
  }

  const esDataUrlValida = (s) =>
    typeof s === "string" &&
    /^data:(image|application)\/[a-zA-Z0-9.+-]+;base64,/.test(s);

  const conceptos = dataSat.Conceptos.flatMap((valueConcepto, index) => {
    let iva = 0;
    let ieps = 0;
    let agregarImpConcepto = 0;
    const relacionDescuento = Number(valueConcepto.Descuento || 0) / Number(valueConcepto.Importe || 1);
    valueConcepto.Impuestos?.Traslados?.forEach((valueImpuesto) => {
      if (valueImpuesto.Impuesto === "002" && valueImpuesto.Importe) {
        iva += valueImpuesto.Importe;
        agregarImpConcepto += valueImpuesto.Importe / (1 - relacionDescuento) - valueImpuesto.Importe;
      }
      if (valueImpuesto.Impuesto === "003" && valueImpuesto.Importe) {
        ieps += valueImpuesto.Importe;
        agregarImpConcepto += valueImpuesto.Importe / (1 - relacionDescuento) - valueImpuesto.Importe;
      }
    });
    agregarImpDesc += agregarImpConcepto;
    // P/U menos el descuento del renglón, en la misma base que la columna P/U
    const precioUnitarioNeto = Number(valueConcepto.ValorUnitario) - Number(valueConcepto.Descuento || 0) / Number(valueConcepto.Cantidad || 1);
    const precioUnitarioNetoConImpuestos = (Number(valueConcepto.Importe) - Number(valueConcepto.Descuento || 0) + iva + ieps) / Number(valueConcepto.Cantidad || 1);

    const imagenesEntrada = Array.isArray(valueConcepto.imagenes) ? valueConcepto.imagenes : [];
    const imagenesBase64 = imagenesEntrada
      .map((img) => (typeof img === "string" ? img : img?.base64Completa))
      .filter(esDataUrlValida);

    const tabla = dataSat.Receptor.impresionEspecial
      ? [
        { style: "textoTablaChico", text: index + 1, alignment: "center" },
        ...(cantidadJuntoPrecioUnitario ? [] : [{ style: "textoTablaChico", text: formatCantidad(valueConcepto.Cantidad), alignment: "center" }]),
        { text: (mostrarDescUnidad && valueConcepto.descUnidad) ? valueConcepto.descUnidad : valueConcepto.ClaveUnidad, style: "textoTablaChico", alignment: "center" },
        { text: valueConcepto.ClaveProdServ, style: "textoTablaChico", alignment: "center" },
        {
          ...(() => {
            const textoDescSinObs =
              valueConcepto.Descripcion +
              (valueConcepto?.CuentaPredial?.[0]?.Numero ? ("\nPredial: " + valueConcepto?.CuentaPredial?.[0]?.Numero) : "") +
              (valueConcepto.Marca ? "\nMarca: " + valueConcepto.Marca : "") +
              (valueConcepto.CodigoBarras ? "\n" + valueConcepto.CodigoBarras : "");
            const textoDesc = textoDescSinObs + (valueConcepto.Observaciones ? "\n" + valueConcepto.Observaciones : "");
            const extras = [];
            if (Array.isArray(valueConcepto.Lotes) && valueConcepto.Lotes.length > 0) {
              extras.push({ text: valueConcepto.Lotes.map(lote => `Cant: ${lote?.cantidadRequerida ?? "-"} - Lote: ${lote?.numero ?? lote?.lote ?? "-"} - Cad: ${lote?.caducidad && moment(lote.caducidad).isSameOrAfter(moment(dataSat.Fecha), 'day') ? moment(lote.caducidad).format("DD/MM/YYYY") : "-"}`).join("\n"), fontSize: pdfFz(5), color: "#555", margin: [0, 2, 0, 0] });
            }
            if (Array.isArray(valueConcepto.ComponentesKit) && valueConcepto.ComponentesKit.length > 0) {
              extras.push({ text: "Incluye: " + valueConcepto.ComponentesKit.map(c => `${c.descripcion} (x${c.cantidad})`).join(", "), fontSize: pdfFz(5), color: "#555", margin: [0, 2, 0, 0] });
            }
            const imgsNode = PDFItemImagesV2(imagenesBase64);
            if (imgsNode) extras.push(imgsNode);
            if (valueConcepto.DescripcionLarga) {
              // Descripcion larga del producto (solo PDF): debajo del concepto y antes de las observaciones
              return {
                stack: [
                  { text: textoDescSinObs, style: "textoTablaChico" },
                  { text: valueConcepto.DescripcionLarga, fontSize: pdfFz(5), color: "#555", margin: [0, 1, 0, 0] },
                  ...(valueConcepto.Observaciones ? [{ text: valueConcepto.Observaciones, style: "textoTablaChico" }] : []),
                  ...extras,
                ],
                alignment: "left",
              };
            }
            if (extras.length) {
              return { stack: [{ text: textoDesc, style: "textoTablaChico" }, ...extras], alignment: "left" };
            }
            return { text: textoDesc, style: "textoTablaChico", alignment: "left" };
          })(),
        },
        ...(cantidadJuntoPrecioUnitario ? [{ style: "textoTablaChico", text: formatCantidad(valueConcepto.Cantidad), alignment: "center" }] : []),
        {
          stack: [
            { text: dineroDisabledMask(valueConcepto.ValorUnitario, decimalesPrecioUnitarioPdf), style: "textoTablaChico", alignment: "left" },
            ...(
              !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
                ? [{
                  columns: [
                    { text: round2Decimals((Number(valueConcepto.Descuento) * 100) / (Number(valueConcepto.Cantidad || 1) * Number(valueConcepto.ValorUnitario || 1))) + "%", width: "*", alignment: "left", style: "descuentoPartida", noWrap: true },
                    { text: dineroDisabledMask(round2Decimals(Number(valueConcepto.Descuento) / Number(valueConcepto.Cantidad || 1))), width: "auto", style: "descuentoPartida" }
                  ],
                  columnGap: 8, margin: [0, 2, 0, 0]
                }]
                : []
            )
          ]
        },
        ...(precioUnitarioConDescuento ? [{ text: dineroDisabledMask(precioUnitarioNeto, decimalesPrecioUnitarioPdf), style: "textoTablaChico", alignment: "left" }] : []),
        ...(ocultarColumnaIVA ? [] : [{ text: dineroDisabledMask(iva), style: "textoTablaChico", alignment: "left" }]),
        { text: dineroDisabledMask(ieps), style: "textoTablaChico", alignment: "left" },
        {
          stack: [
            { text: dineroDisabledMask(valueConcepto.Importe), style: "textoTablaChico", alignment: "left" },
            ...(
              !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
                ? [{ text: "- " + dineroDisabledMask(Number(valueConcepto.Descuento)), style: "descuentoPartida", alignment: "left", margin: [0, 2, 0, 0] }]
                : []
            )
          ]
        }
      ]
      : [
        { style: "textoTablaChico", text: index + 1, alignment: "center" },
        ...(cantidadJuntoPrecioUnitario ? [] : [{ style: "textoTablaChico", text: formatCantidad(valueConcepto.Cantidad), alignment: "right" }]),
        { text: (mostrarDescUnidad && valueConcepto.descUnidad) ? valueConcepto.descUnidad : valueConcepto.ClaveUnidad, style: "textoTablaChico", alignment: "center" },
        ...(mostrarClaveSAT ? [{ text: valueConcepto.ClaveProdServ, style: "textoTablaChico", alignment: "center" }] : []),
        ...(mostrarClave ? [{ text: valueConcepto.NoIdentificacion, style: "textoTablaChico", alignment: "center" }] : []),
        {
          ...(() => {
            const textoDescSinObs =
              valueConcepto.Descripcion +
              (valueConcepto?.CuentaPredial?.[0]?.Numero ? ("\nPredial: " + valueConcepto?.CuentaPredial?.[0]?.Numero) : "") +
              (valueConcepto.Marca ? "\nMarca: " + valueConcepto.Marca : "") +
              (valueConcepto.CodigoBarras ? "\n" + valueConcepto.CodigoBarras : "");
            const textoDesc = textoDescSinObs + (valueConcepto.Observaciones ? "\n" + valueConcepto.Observaciones : "");
            const extras = [];
            if (Array.isArray(valueConcepto.Lotes) && valueConcepto.Lotes.length > 0) {
              extras.push({ text: valueConcepto.Lotes.map(lote => `Cant: ${lote?.cantidadRequerida ?? "-"} - Lote: ${lote?.numero ?? lote?.lote ?? "-"} - Cad: ${lote?.caducidad && moment(lote.caducidad).isSameOrAfter(moment(dataSat.Fecha), 'day') ? moment(lote.caducidad).format("DD/MM/YYYY") : "-"}`).join("\n"), fontSize: pdfFz(5), color: "#555", margin: [0, 2, 0, 0] });
            }
            if (Array.isArray(valueConcepto.ComponentesKit) && valueConcepto.ComponentesKit.length > 0) {
              extras.push({ text: "Incluye: " + valueConcepto.ComponentesKit.map(c => `${c.descripcion} (x${c.cantidad})`).join(", "), fontSize: pdfFz(5), color: "#555", margin: [0, 2, 0, 0] });
            }
            const imgsNode = PDFItemImagesV2(imagenesBase64);
            if (imgsNode) extras.push(imgsNode);
            if (valueConcepto.DescripcionLarga) {
              // Descripcion larga del producto (solo PDF): debajo del concepto y antes de las observaciones
              return {
                stack: [
                  { text: textoDescSinObs, style: "textoTablaChico" },
                  { text: valueConcepto.DescripcionLarga, fontSize: pdfFz(5), color: "#555", margin: [0, 1, 0, 0] },
                  ...(valueConcepto.Observaciones ? [{ text: valueConcepto.Observaciones, style: "textoTablaChico" }] : []),
                  ...extras,
                ],
                alignment: "left",
              };
            }
            if (extras.length) {
              return { stack: [{ text: textoDesc, style: "textoTablaChico" }, ...extras], alignment: "left" };
            }
            return { text: textoDesc, style: "textoTablaChico", alignment: "left" };
          })(),
        },
        ...(cantidadJuntoPrecioUnitario ? [{ style: "textoTablaChico", text: formatCantidad(valueConcepto.Cantidad), alignment: "right" }] : []),
        {
          stack: [
            {
              text: dineroDisabledMask(
                quitarImpuestosFacturas
                  ? (Number(valueConcepto.Importe) + iva + ieps + agregarImpConcepto) / Number(valueConcepto.Cantidad || 1)
                  : valueConcepto.ValorUnitario,
                decimalesPrecioUnitarioPdf
              ), style: "textoTablaChico", alignment: "right", noWrap: true
            },
            ...(
              !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
                ? [{
                  columns: [
                    { text: round2Decimals((Number(valueConcepto.Descuento) * 100) / (Number(valueConcepto.Cantidad || 1) * Number(valueConcepto.ValorUnitario || 1))) + "%", width: "*", alignment: "left", style: "descuentoPartida", noWrap: true },
                    { text: dineroDisabledMask(round2Decimals(Number(valueConcepto.Descuento) / Number(valueConcepto.Cantidad || 1))), width: "auto", style: "descuentoPartida" }
                  ],
                  columnGap: 8, margin: [0, 2, 0, 0]
                }]
                : []
            )
          ]
        },
        ...(precioUnitarioConDescuento ? [{
          text: dineroDisabledMask(quitarImpuestosFacturas ? precioUnitarioNetoConImpuestos : precioUnitarioNeto, decimalesPrecioUnitarioPdf),
          style: "textoTablaChico", alignment: "right", noWrap: true
        }] : []),
        ...(quitarImpuestosFacturas ? [] : [
          ...(ocultarColumnaIVA ? [] : [{ text: dineroDisabledMask(iva), style: "textoTablaChico", alignment: "right", noWrap: true }]),
          ...(empresa.imprimirIEPS ? [{ text: dineroDisabledMask(ieps), style: "textoTablaChico", alignment: "right", noWrap: true }] : []),
        ]),
        {
          stack: [
            {
              text: dineroDisabledMask(
                quitarImpuestosFacturas
                  ? Number(valueConcepto.Importe) + iva + ieps + agregarImpConcepto
                  : importeConImpuestos
                    ? Number(valueConcepto.Importe) - Number(valueConcepto.Descuento || 0) + iva + ieps
                    : valueConcepto.Importe
              ), style: "textoTablaChico", alignment: "right", noWrap: true
            },
            ...(
              !importeConImpuestos && !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
                ? [{ text: "- " + dineroDisabledMask(Number(valueConcepto.Descuento)), style: "descuentoPartida", alignment: "right", margin: [0, 2, 0, 0] }]
                : []
            )
          ]
        }
      ];

    return [tabla];
  });

  const nuevoArrayImpFL = Array.isArray(dataSat.Impuestos.Traslados)
    ? [...dataSat.Impuestos.Traslados, ...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:TrasladosLocales"] || [])]
    : [...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:TrasladosLocales"] || [])];

  const ordenImpuestos = ["IVA 0%", "IVA 16%", "IEPS 6%", "IEPS 7%", "IEPS 9%"];

  const nuevoArrayImpFLOdenado = [...nuevoArrayImpFL].sort((a, b) => {
    const nombreA = a.Impuesto === "002" ? `IVA ${round2Decimals(a.TasaOCuota * 100)}%` : a.Impuesto === "003" ? `IEPS ${round2Decimals(a.TasaOCuota * 100)}%` : a["@ImpLocTrasladado"];
    const nombreB = b.Impuesto === "002" ? `IVA ${round2Decimals(b.TasaOCuota * 100)}%` : b.Impuesto === "003" ? `IEPS ${round2Decimals(b.TasaOCuota * 100)}%` : b["@ImpLocTrasladado"];
    return ordenImpuestos.indexOf(nombreA) - ordenImpuestos.indexOf(nombreB);
  });

  const impuestosTotales = nuevoArrayImpFLOdenado.map((valueImpuesto) => {
    let nombre = "";
    if (valueImpuesto.Impuesto === "002") nombre = "IVA";
    else if (valueImpuesto.Impuesto === "003") nombre = "IEPS";
    else nombre = valueImpuesto["@ImpLocTrasladado"];
    if (valueImpuesto.TipoFactor === "Tasa") nombre = nombre + " " + round2Decimals(valueImpuesto.TasaOCuota * 100) + "%";
    else if (valueImpuesto.TipoFactor === "Cuota") nombre = nombre + " $" + round2Decimals(valueImpuesto.TasaOCuota);
    return { label: nombre, value: dineroDisabledMask(valueImpuesto.Importe || valueImpuesto["@Importe"] || 0) };
  });

  const nuevoArrayRetFL = Array.isArray(dataSat.Impuestos.Retenciones)
    ? [...dataSat.Impuestos.Retenciones, ...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:RetencionesLocales"] || [])]
    : [...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:RetencionesLocales"] || [])];

  const retencionesTotales = nuevoArrayRetFL.map((valueRetencion) => {
    let nombre = "Retención ";
    if (valueRetencion.Impuesto === "001") nombre = nombre + "ISR";
    else if (valueRetencion.Impuesto === "002") nombre = nombre + "IVA";
    else nombre = valueRetencion["@ImpLocRetenido"];
    return { label: nombre, value: dineroDisabledMask(valueRetencion.Importe || valueRetencion["@Importe"]) };
  });

  const totalImpFL = dataSat.Impuestos.TotalImpuestosTrasladados + (dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["@TotaldeTraslados"] || 0) || 0;
  const totalRetFL = dataSat.Impuestos.TotalImpuestosRetenidos + (dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["@TotaldeRetenciones"] || 0) || 0;

  let cancelado = {};
  if (values.estado === 0) {
    cancelado = { watermark: { text: 'CANCELADO', color: 'GRAY', opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 } };
  } else if (values.esPreview) {
    cancelado = { watermark: { text: 'VISTA PREVIA', color: '#1677ff', opacity: 0.15, bold: true, italics: false, angle: -50, fontSize: 90 } };
  }

  const mostrarBancos = !empresa?.deshabilitarBancoFactura && !dataSat?.deshabilitarBanco;

  const filasBanco1 = [
    { label: "Banco:", value: empresa.banco ? empresa.banco : "" },
    ...(empresa.swiftCode ? [{ label: "Swift Code:", value: empresa.swiftCode ? empresa.swiftCode : "" }] : []),
    ...(empresa.abaCode ? [{ label: "ABA Code:", value: empresa.abaCode ? empresa.abaCode : "" }] : []),
    { label: "Cuenta:", value: empresa.cuentaBanco ? empresa.cuentaBanco : "" },
    { label: "Cuenta CLABE:", value: empresa.cuentaClabe ? empresa.cuentaClabe : "" },
  ];

  const filasBanco2 = empresa.banco2 && empresa.banco2 !== ""
    ? [
      { label: "Banco:", value: empresa.banco2 ? empresa.banco2 : "" },
      ...(empresa.swiftCode2 ? [{ label: "Swift Code:", value: empresa.swiftCode2 ? empresa.swiftCode2 : "" }] : []),
      ...(empresa.abaCode2 ? [{ label: "ABA Code:", value: empresa.abaCode2 ? empresa.abaCode2 : "" }] : []),
      { label: "Cuenta:", value: empresa.cuentaBanco2 ? empresa.cuentaBanco2 : "" },
      { label: "Cuenta CLABE:", value: empresa.cuentaClabe2 ? empresa.cuentaClabe2 : "" },
    ]
    : [];

  // --- Datos carta porte (mismas estructuras que el clásico) ---
  let ubicaciones = [];
  if (cartaPorte?.Ubicaciones) {
    for (const ubicacion of cartaPorte.Ubicaciones) {
      ubicaciones.push(
        [
          { style: 'textoTablaChico', text: ubicacion.TipoUbicacion + ' - ' + ubicacion.IDUbicacion, alignment: 'center' },
          { style: 'textoTablaChico', text: ubicacion.RFCRemitenteDestinatario, alignment: 'center' },
          { style: 'textoTablaChico', text: ubicacion.NombreRemitenteDestinatario, alignment: 'lefth' },
          { text: 'MXN', style: 'textoTablaChico', alignment: 'center' },
          { text: '-', style: 'textoTablaChico', alignment: 'center' },
          { text: ubicacion.FechaHoraSalidaLlegada, style: 'textoTablaChico', alignment: 'center' },
        ],
        [
          { style: 'textoTablaChico', text: 'Domicilio:', alignment: 'lefth' },
          { style: 'textoTablaChico', text: (ubicacion.Domicilio.Calle ? ubicacion.Domicilio.Calle : '') + (ubicacion.Domicilio.NumeroExterior ? (' #' + ubicacion.Domicilio.NumeroExterior) : '') + (ubicacion.Domicilio.NumeroInterior ? (' - ' + ubicacion.Domicilio.NumeroInterior) : '') + ' Col: ' + ubicacion.Domicilio.ColoniaNombre + ' CP: ' + ubicacion.Domicilio.CodigoPostal + (ubicacion.Domicilio.Referencia ? (' Referencia: ' + ubicacion.Domicilio.Referencia) : '') + ' - ' + (ubicacion.Domicilio.MunicipioNombre ? ubicacion.Domicilio.MunicipioNombre : '') + ' ' + ubicacion.Domicilio.Estado + ' ' + ubicacion.Domicilio.Pais, alignment: 'lefth', colSpan: 5 },
          {}, {}, {}, {},
        ]
      );
    }
  }

  let figuras = [];
  if (cartaPorte?.FiguraTransporte) {
    for (const figura of cartaPorte.FiguraTransporte) {
      let tipoFiguraTexto;
      if (figura.TipoFigura === '01') tipoFiguraTexto = "Operador";
      else if (figura.TipoFigura === '02') tipoFiguraTexto = "Propietario";
      else if (figura.TipoFigura === '03') tipoFiguraTexto = "Arrendador";
      else if (figura.TipoFigura === '04') tipoFiguraTexto = "Notificado";

      const filaDomicilioFigura = figura?.Domicilio && Object.keys(figura.Domicilio).length > 0
        ? [[
          { style: 'textoTablaChico', text: 'Domicilio:', alignment: 'left' },
          {
            style: 'textoTablaChico',
            text:
              (figura.Domicilio.Calle ? figura.Domicilio.Calle : '') +
              (figura.Domicilio.NumeroExterior ? ` #${figura.Domicilio.NumeroExterior}` : '') +
              (figura.Domicilio.NumeroInterior ? ` - ${figura.Domicilio.NumeroInterior}` : '') +
              (figura.Domicilio.ColoniaNombre ? ` Col: ${figura.Domicilio.ColoniaNombre}` : '') +
              (figura.Domicilio.CodigoPostal ? ` CP: ${figura.Domicilio.CodigoPostal}` : '') +
              (figura.Domicilio.Referencia ? ` Referencia: ${figura.Domicilio.Referencia}` : '') +
              (figura.Domicilio.MunicipioNombre ? ` - ${figura.Domicilio.MunicipioNombre}` : '') +
              (figura.Domicilio.Estado ? ` ${figura.Domicilio.Estado}` : '') +
              (figura.Domicilio.Pais ? ` ${figura.Domicilio.Pais}` : ''),
            alignment: 'left', colSpan: 5
          },
          {}, {}, {}, {}
        ]]
        : [];

      figuras.push(
        [
          { style: 'textoTablaChico', text: figura.TipoFigura + ' - ' + tipoFiguraTexto, alignment: 'center' },
          { style: 'textoTablaChico', text: figura.RFCFigura, alignment: 'center' },
          { style: 'textoTablaChico', text: figura.NombreFigura, alignment: 'lefth' },
          { text: figura.NumLicencia, style: 'textoTablaChico', alignment: 'center' },
          { text: figura.ResidenciaFiscalFigura ? figura.ResidenciaFiscalFigura : '-', style: 'textoTablaChico', alignment: 'center' },
          { text: figura.NumRegIdTribFigura ? figura.NumRegIdTribFigura : '-', style: 'textoTablaChico', alignment: 'center' },
        ],
        ...filaDomicilioFigura
      );
    }
  }

  let mercancias = [];
  if (cartaPorte?.Mercancias?.Mercancia) {
    for (const mercancia of cartaPorte.Mercancias.Mercancia) {
      let agregarFinalMercancias = [];
      let cantidadTotal = 0;
      if (mercancia.CantidadTransporta) {
        for (const cantidad of mercancia.CantidadTransporta) {
          cantidadTotal += cantidad.Cantidad;
          const ubicacionOrigen = cartaPorte?.Ubicaciones.find(valueUbi => valueUbi.IDUbicacion === cantidad.IDOrigen);
          const ubicacionDestino = cartaPorte?.Ubicaciones.find(valueUbi => valueUbi.IDUbicacion === cantidad.IDDestino);
          agregarFinalMercancias.push([
            { style: 'textoTablaChico', text: cantidad.Cantidad, alignment: 'right' },
            { style: 'textoTablaChico', text: 'Origen: ' + ubicacionOrigen.IDUbicacion + ' - ' + (ubicacionOrigen.Domicilio.Calle ? ubicacionOrigen.Domicilio.Calle : '') + (ubicacionOrigen.Domicilio.NumeroExterior ? (' #' + ubicacionOrigen.Domicilio.NumeroExterior) : '') + (ubicacionOrigen.Domicilio.NumeroInterior ? (' - ' + ubicacionOrigen.Domicilio.NumeroInterior) : '') + ' Col: ' + ubicacionOrigen.Domicilio.ColoniaNombre + ' CP: ' + ubicacionOrigen.Domicilio.CodigoPostal + (ubicacionOrigen.Domicilio.Referencia ? (' Referencia: ' + ubicacionOrigen.Domicilio.Referencia) : '') + ' - ' + (ubicacionOrigen.Domicilio.MunicipioNombre ? ubicacionOrigen.Domicilio.MunicipioNombre : '') + ' ' + ubicacionOrigen.Domicilio.Estado + ' ' + ubicacionOrigen.Domicilio.Pais, alignment: 'lefth', colSpan: 3 },
            {},
            {},
            { style: 'textoTablaChico', text: 'Destino: ' + ubicacionDestino.IDUbicacion + ' - ' + (ubicacionDestino.Domicilio.Calle ? ubicacionDestino.Domicilio.Calle : '') + (ubicacionDestino.Domicilio.NumeroExterior ? (' #' + ubicacionDestino.Domicilio.NumeroExterior) : '') + (ubicacionDestino.Domicilio.NumeroInterior ? (' - ' + ubicacionDestino.Domicilio.NumeroInterior) : '') + ' Col: ' + ubicacionDestino.Domicilio.ColoniaNombre + ' CP: ' + ubicacionDestino.Domicilio.CodigoPostal + (ubicacionDestino.Domicilio.Referencia ? (' Referencia: ' + ubicacionDestino.Domicilio.Referencia) : '') + ' - ' + (ubicacionDestino.Domicilio.MunicipioNombre ? ubicacionDestino.Domicilio.MunicipioNombre : '') + ' ' + ubicacionDestino.Domicilio.Estado + ' ' + ubicacionDestino.Domicilio.Pais, alignment: 'lefth', colSpan: 4 },
            {},
            {},
            {},
          ]);
        }
      }
      mercancias.push([
        { style: 'textoTablaChico', text: cantidadTotal, alignment: 'right' },
        { text: mercancia.Unidad, style: 'textoTablaChico', alignment: 'center' },
        { text: mercancia.BienesTransp + ' - ' + mercancia.Descripcion, style: 'textoTablaChico', alignment: 'center' },
        { text: mercancia.CveMaterialPeligroso ? mercancia.CveMaterialPeligroso : 'No', style: 'textoTablaChico', alignment: 'left' },
        { text: mercancia.Embalaje ? (mercancia.Embalaje + ' - ' + mercancia.DescripEmbalaje) : '-', style: 'textoTablaChico', alignment: 'right' },
        { text: mercancia.PesoEnKg, style: 'textoTablaChico', alignment: 'right' },
        { text: mercancia.FraccionArancelaria, style: 'textoTablaChico', alignment: 'right' },
        { text: mercancia.PermisoImportacion ? mercancia.PermisoImportacion : '-', style: 'textoTablaChico', alignment: 'right' }
      ]);
      if (mercancia.GuiasIdentificacion) {
        for (const guiaIdent of mercancia.GuiasIdentificacion) {
          mercancia.push([
            { text: 'No. de Guia', style: 'tituloTabla', colSpan: 2 },
            {},
            { text: guiaIdent.NumeroGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right' },
            { text: 'Descripción Guía', style: 'tituloTabla' },
            { text: guiaIdent.DescripGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right', colSpan: 2 },
            {},
            { text: 'Peso Guía', style: 'tituloTabla' },
            { text: guiaIdent.PesoGuiaIdentificacion, style: 'textoTablaChico', alignment: 'right' }
          ]);
        }
      }
      for (const agregarFinalMercancia of agregarFinalMercancias) {
        mercancias.push(agregarFinalMercancia);
      }
    }
  }

  let remolquesData = [];
  if (cartaPorte?.Mercancias?.Autotransporte?.Remolques) {
    remolquesData = cartaPorte.Mercancias.Autotransporte.Remolques.map(valueR => [
      { text: valueR.SubTipoRem + ' - ' + valueR.DescripcionSubtipo, style: 'textoTablaChico', alignment: 'center' },
      { text: valueR.Placa, style: 'textoTablaChico', alignment: 'center' },
    ]);
  }

  // QR Carta Porte
  let qrCartaPorte = '';
  if (cartaPorte) {
    const formatearFechaSAT = (fechaISO) => {
      try {
        let fechaStr = '';
        if (fechaISO && typeof fechaISO === 'object' && typeof fechaISO.toISOString === 'function' && fechaISO._isAMomentObject) fechaStr = fechaISO.toISOString();
        else if (fechaISO instanceof Date) fechaStr = fechaISO.toISOString();
        else if (typeof fechaISO === 'string') fechaStr = fechaISO;
        else return '';
        return fechaStr.replace('Z', '').split('.')[0];
      } catch { return ''; }
    };
    if (Array.isArray(cartaPorte?.Ubicaciones) && dataSat?.Fecha && cartaPorte["IdCCP"]) {
      const origen = cartaPorte.Ubicaciones.find(ubi => ubi.TipoUbicacion === 'Origen');
      if (origen) {
        const fechaOrig = formatearFechaSAT(origen.FechaHoraSalidaLlegada);
        const fechaTimb = formatearFechaSAT(dataSat.Fecha);
        qrCartaPorte = `https://verificacfdi.facturaelectronica.sat.gob.mx/verificaccp/default.aspx?IdCCP=${cartaPorte["IdCCP"]}&FechaOrig=${fechaOrig}&FechaTimb=${fechaTimb}`;
      }
    }
  }

  const agregarCartaPorte = PDFCartaPorteV2({ cartaPorte, ubicaciones, figuras, mercancias, remolquesData, qrCartaPorte });

  // --- Complemento Comercio Exterior (v2) ---
  const tituloCE = (t) => ({ text: t, style: "tituloTabla" });
  const datoCE = (t) => ({ text: t, style: "textoTablaChico", alignment: "center" });
  const seccionTituloCE = (t) => seccionHeadingV2(t);
  let comercioExterior = [];
  if (complementoComercioExterior) {
    comercioExterior = [
      seccionTituloCE("Detalle Complemento Comercio Exterior"),
      {
        style: "tableExample",
        table: {
          widths: ['20%', '20%', '20%', '20%', '20%'],
          body: [
            [tituloCE('Versión'), tituloCE('Certificado de origen'), tituloCE('Clave de pedimento'), tituloCE('Incoterm'), tituloCE('Tipo de cambio USD')],
            [
              datoCE(complementoComercioExterior?.Version || '-'),
              datoCE(complementoComercioExterior?.CertificadoOrigen || '-'),
              datoCE(complementoComercioExterior?.ClaveDePedimento || '-'),
              datoCE(complementoComercioExterior?.Incoterm || '-'),
              datoCE(complementoComercioExterior?.TipoCambioUSD || '-'),
            ],
            [tituloCE('Total USD'), { text: '', style: 'tituloTabla', colSpan: 4 }, {}, {}, {}],
            [datoCE(complementoComercioExterior?.TotalUSD || '-'), { text: '', colSpan: 4 }, {}, {}, {}],
          ],
        },
        layout: lineLayoutsV2.rejilla,
      },
      seccionTituloCE("Domicilios Emisor y Receptor"),
      {
        style: "tableExample",
        table: {
          widths: ['50%', '50%'],
          body: [
            [tituloCE('Domicilio del emisor'), tituloCE('Domicilio del receptor')],
            [
              {
                style: 'textoTablaChico',
                stack: [
                  complementoComercioExterior?.Emisor?.Domicilio?.Calle || '',
                  `CP: ${complementoComercioExterior?.Emisor?.Domicilio?.CodigoPostal || ''}  Col: ${complementoComercioExterior?.Emisor?.Domicilio?.Colonia || ''}`,
                  `Mun: ${complementoComercioExterior?.Emisor?.Domicilio?.Municipio || ''}  Loc: ${complementoComercioExterior?.Emisor?.Domicilio?.Localidad || ''}`,
                  `Estado: ${complementoComercioExterior?.Emisor?.Domicilio?.Estado || ''}  País: ${complementoComercioExterior?.Emisor?.Domicilio?.Pais || ''}`,
                ],
              },
              {
                style: 'textoTablaChico',
                stack: [
                  complementoComercioExterior?.Receptor?.Domicilio?.Calle || '',
                  `CP: ${complementoComercioExterior?.Receptor?.Domicilio?.CodigoPostal || ''}  Col: ${complementoComercioExterior?.Receptor?.Domicilio?.Colonia || ''}`,
                  `Mun: ${complementoComercioExterior?.Receptor?.Domicilio?.Municipio || ''}  Loc: ${complementoComercioExterior?.Receptor?.Domicilio?.Localidad || ''}`,
                  `Estado: ${complementoComercioExterior?.Receptor?.Domicilio?.Estado || ''}  País: ${complementoComercioExterior?.Receptor?.Domicilio?.Pais || ''}`,
                ],
              },
            ],
          ],
        },
        layout: lineLayoutsV2.rejilla,
      },
      seccionTituloCE("Detalle de Mercancías"),
      {
        style: "tableExample",
        table: {
          widths: ['18%', '22%', '13%', '12%', '17%', '18%'],
          body: [
            [tituloCE('No. identificación'), tituloCE('Fracción arancelaria'), tituloCE('Cantidad aduana'), tituloCE('Unidad aduana'), tituloCE('Valor unitario aduana'), tituloCE('Valor dólares')],
            ...((complementoComercioExterior?.Mercancias || []).map((m) => ([
              { text: m.NoIdentificacion || '-', style: 'textoTablaChico', alignment: 'center' },
              { text: m.FraccionArancelaria || '-', style: 'textoTablaChico', alignment: 'center' },
              { text: m.CantidadAduana || '-', style: 'textoTablaChico', alignment: 'right' },
              { text: m.UnidadAduana || '-', style: 'textoTablaChico', alignment: 'center' },
              { text: m.ValorUnitarioAduana || '-', style: 'textoTablaChico', alignment: 'right' },
              { text: m.ValorDolares || '-', style: 'textoTablaChico', alignment: 'right' },
            ]))),
          ],
        },
        layout: lineLayoutsV2.rejilla,
      },
    ];
  }

  const total = dataSat.SubTotal - dataSat.Descuento + totalImpFL;
  const totalqr = formatQRTotal(dataSat.Total);
  let cadena8 = dataExtra.selloCFDI;
  cadena8 = cadena8.slice(-8);
  const linkqr = `https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?&id=${dataExtra.uuid}&re=${empresa.rfc}&rr=${dataSat.Receptor.Rfc}&tt=${totalqr}&fe=${cadena8}`;

  const vendedorVar = (empresa.vendedorVentas && values.vendedor) ? values.vendedor : null;
  const regimenFiscal = dataSat?.Receptor?.RegimenFiscal?.trim();

  // --- Pagaré ---
  let anadirPagare = [];
  if (values.imprimirPagare && values.textoPagare) {
    anadirPagare = PDFPagareV2({
      empresa,
      meta: [
        { label: "N° Factura:", value: (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio },
        { label: "Moneda:", value: dataSat.Moneda },
        { label: "Tipo de Cambio:", value: dineroDisabledMask(dataSat.TipoCambio, decimalesTipoCambioPdf) },
      ],
      buenoPor: dineroDisabledMask(dataSat.Total),
      texto: values.textoPagare,
      pagareCorto: values.pagareCorto,
    });
  }

  // --- impresión especial (inglés) ---
  const impresionEspecial = dataSat.Receptor.impresionEspecial
    ? [
      PDFCompanyInfoV2({
        left: [
          { label: "Purchase Order #:", value: dataSat?.pedido ? dataSat.pedido : 'N/A' },
          { label: "Invoice number:", value: (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio },
          { label: "Invoice date:", value: moment(dataSat.Fecha).locale("es").format("DD/MM/YYYY") },
        ],
        right: [
          { label: "Terms:", value: (dataSat?.Receptor?.diasCredito && dataSat?.Receptor?.diasCredito > 0) ? (dataSat?.Receptor?.diasCredito + " days") : "Immediate Payment" },
          { label: "Seller:", value: (empresa.nombreComercial ? empresa.nombreComercial : empresa.persona ? empresa.nombre : empresa.nombre + " " + empresa.apellidoPaterno + " " + empresa.apellidoMaterno) },
        ],
        labelWidthLeft: "40%",
        labelWidthRight: "40%",
      }),
    ]
    : [];

  // --- CFDI relacionados ---
  const getDescripcionTipoRelacion = (tipo) => {
    switch (tipo) {
      case "01": return "01 - Nota de crédito de los documentos relacionados";
      case "02": return "02 - Nota de débito de los documentos relacionados";
      case "03": return "03 - Devolución de mercancía sobre facturas o traslados previos";
      case "04": return "04 - Sustitución de los CFDI previos";
      case "05": return "05 - Traslados de mercancías facturados previamente";
      case "06": return "06 - Factura generada por los traslados previos";
      case "07": return "07 - CFDI por aplicación de anticipo";
      default: return tipo;
    }
  };
  const filasCfdiRelacionados = [];
  if (values.relacionesCFDI && Array.isArray(values.relacionesCFDI)) {
    values.relacionesCFDI.forEach(relacion => {
      filasCfdiRelacionados.push([
        { text: getDescripcionTipoRelacion(relacion.tipoRelacion), style: 'textoTablaChico', alignment: 'left' },
        { text: relacion.uuid, style: 'textoTablaChico', alignment: 'left', color: PDF_COLORS.ink },
      ]);
    });
  }
  let tablaCfdiRelacionados = [];
  if (filasCfdiRelacionados.length > 0) {
    tablaCfdiRelacionados.push(
      seccionHeadingV2("CFDI Relacionados"),
      {
        style: "tableExample",
        table: {
          headerRows: 1,
          widths: ['52%', '48%'],
          body: [
            [
              { text: "Tipo de relación", style: "tituloTabla", alignment: "left", fillColor: PDF_COLORS.tint },
              { text: "Folio Fiscal (UUID)", style: "tituloTabla", alignment: "left", fillColor: PDF_COLORS.tint },
            ],
            ...filasCfdiRelacionados,
          ],
        },
        // Layout limpio: línea fina bajo el encabezado y al pie, sin rejilla por
        // fila (acorde a la tabla de conceptos), compacto.
        layout: {
          fillColor: () => null,
          hLineWidth: (i, node) => (i === 1 ? 1 : i === node.table.body.length ? 0.8 : 0),
          hLineColor: () => PDF_COLORS.tableDivider,
          vLineWidth: () => 0,
          paddingTop: () => 3,
          paddingBottom: () => 3,
          paddingLeft: () => 2,
          paddingRight: () => 6,
        },
      }
    );
  }

  // --- advansLeyenda ---
  let advansLeyenda = [];
  if (dataSat?.Receptor?.advansLeyenda) {
    advansLeyenda = [{
      style: "tableExample",
      table: {
        widths: ['*'],
        body: [[{ text: dataSat?.Receptor?.advansLeyenda, margin: [0, 4, 0, 4], style: "textoChico", border: [false, false, false, false] }]],
      },
      layout: lineLayoutsV2.cajaLimpia,
    }];
  }

  // --- Complemento SAT de Leyendas Fiscales (v2) ---
  let leyendasFiscales = [];
  const nodoLeyendasFisc = dataSat?.Complemento?.Any?.find(item => item['leyendasFisc:LeyendasFiscales']);
  if (nodoLeyendasFisc) {
    const hijosLeyendas = nodoLeyendasFisc['leyendasFisc:LeyendasFiscales']['leyendasFisc:Leyenda'];
    const listaLeyendas = Array.isArray(hijosLeyendas) ? hijosLeyendas : (hijosLeyendas ? [hijosLeyendas] : []);

    // pdfmake truena con un table.body vacio
    if (listaLeyendas.length > 0) {
      leyendasFiscales = [
        seccionHeadingV2("Leyendas Fiscales"),
        {
          style: "tableExample",
          margin: [0, 0, 0, 4],
          table: {
            widths: ['*'],
            body: listaLeyendas.map((valueLeyenda, indexLeyenda) => ([
              {
                margin: [0, indexLeyenda === 0 ? 0 : 4, 0, 4],
                border: [false, false, false, false],
                stack: [
                  valueLeyenda['@disposicionFiscal']
                    ? { text: "Disposición Fiscal: " + valueLeyenda['@disposicionFiscal'], style: "textoChico", fontSize: pdfFz(5.5) }
                    : null,
                  valueLeyenda['@norma']
                    ? { text: "Norma: " + valueLeyenda['@norma'], style: "textoChico", fontSize: pdfFz(5.5) }
                    : null,
                  { text: valueLeyenda['@textoLeyenda'] || "", style: "textoChico", fontSize: pdfFz(5.5) },
                ].filter(Boolean),
              },
            ])),
          },
          layout: { ...lineLayoutsV2.cajaLimpia, paddingTop: (i) => (i === 0 ? 0 : 8) },
        },
      ];
    }
  }

  // --- Encabezado de información del documento (columna derecha) ---
  const headerMeta = [
    ...(numeroRemision ? [{ label: "N° Remisión:", value: (serieRemision ? serieRemision : 'R') + ' - ' + numeroRemision }] : []),
    { label: "Fecha de emisión:", value: moment(dataSat.Fecha).locale("es").format("LL") },
    { label: "Moneda:", value: dataSat.Moneda },
    { label: "Tipo de cambio:", value: dineroDisabledMask(dataSat.TipoCambio, decimalesTipoCambioPdf) },
    { label: "Forma de pago:", value: "(" + dataSat.formaDePago.c_FormaPago + ") " + dataSat.formaDePago.descripcion },
    { label: "Método de pago:", value: dataSat.MetodoPago === "PUE" ? "PUE - Pago en una sola exhibición" : "PPD - Pago en parcialidades o diferido" },
    { label: "Condiciones de pago:", value: dataSat.condicion === 1 ? "Contado" : "Crédito (" + (dataSat?.Receptor?.diasCredito ? dataSat?.Receptor?.diasCredito : "0") + " días)" },
    { label: "Lugar de expedición:", value: dataSat.LugarExpedicion },
    ...(mostrarOC && dataSat.pedido ? [{ label: "O.C.:", value: dataSat.pedido }] : []),
    ...(dataSat.req ? [{ label: "Req:", value: dataSat.req }] : []),
    ...(vendedorVar ? [{ label: "Vendedor:", value: vendedorVar.nombre + (vendedorVar.apellidoPaterno ? (" " + vendedorVar.apellidoPaterno) : "") + (vendedorVar.apellidoMaterno ? (" " + vendedorVar.apellidoMaterno) : "") }] : []),
    ...(dataSat.Exportacion && dataSat.Exportacion !== "01" ? [{ label: "Exportación:", value: dataSat.Exportacion }] : []),
  ];

  // --- Cliente (identidad del receptor) ---
  const clienteLeft = [
    { label: "Nombre del cliente:", value: dataSat.Receptor.Nombre, strong: true },
    { label: "R.F.C:", value: dataSat.Receptor.Rfc },
    ...(dataSat?.Receptor?.NumRegIdTrib ? [{ label: "ID Tributario:", value: dataSat.Receptor.NumRegIdTrib }] : []),
    ...(dataSat?.Receptor?.codigoProveedor ? [{ label: "Código Proveedor:", value: dataSat.Receptor.codigoProveedor }] : []),
    ...(regimenFiscal ? [{ label: "Regimen Fiscal:", value: regimenFiscal }] : []),
    { label: "Uso de CFDI:", value: "(" + dataSat.usoDeCFDI.c_UsoCFDI + ") " + dataSat.usoDeCFDI.descripcion },
    ...(dataSat?.Receptor?.DireccionExtranjera ? [{ label: "Dirección:", value: dataSat.Receptor.DireccionExtranjera }] : []),
    { label: "CP:", value: dataSat?.Receptor?.DomicilioFiscalReceptor ? dataSat.Receptor.DomicilioFiscalReceptor : '' },
  ];

  // Dirección de entrega como una sola cadena continua (estilo Maps, comas).
  const { referencia: referenciaEntrega, direccion: direccionEntregaTexto } = formatearDireccionEntrega(
    direccionEntrega,
    { mostrarReferencia: !!empresa?.mostrarReferenciaEntregaPdf }
  );

  const clienteRight = [
    ...(empresa?.mostrarProyectoVentas ? [{ label: "Proyecto:", value: proyecto, strong: true }] : []),
    ...((dataSat.condicion === 2 && dataSat.Receptor.diasCredito) ? [{ label: "Dias de credito:", value: dataSat.Receptor.diasCredito }] : []),
    ...(direccionEntrega?.clienteNombre ? [{ label: "Cliente entrega:", value: direccionEntrega?.clienteNombre }] : []),
    ...(direccionEntrega?.clienteRfc ? [{ label: "RFC entrega:", value: direccionEntrega?.clienteRfc }] : []),
    ...(referenciaEntrega ? [{ label: "Referencia:", value: referenciaEntrega }] : []),
    ...(direccionEntrega?.destino ? [{ label: "Destino:", value: direccionEntrega?.destino }] : []),
    ...(direccionEntrega?.embarque ? [{ label: "Embarque:", value: direccionEntrega?.embarque }] : []),
    ...(direccionEntregaTexto ? [{ label: "Dirección de Entrega:", value: direccionEntregaTexto }] : []),
    ...(mostrarFechaEntrega && dataSat.fechaEntregaEstimada ? [{ label: "Fecha de entrega estimada:", value: moment(dataSat.fechaEntregaEstimada).locale("es").format("LL") }] : []),
    ...(dataSat?.atencion ? [{ label: "Atención a:", value: dataSat.atencion }] : []),
  ];

  // --- Cierre: importe con letra + datos bancarios (izquierda) ---
  // Solo se muestran filas bancarias con valor visible; si ninguna lo tiene,
  // se oculta toda la sección "Datos bancarios" (incluido su título).
  const bancosRows = (mostrarBancos ? [...filasBanco1, ...filasBanco2] : [])
    .filter((r) => r && String(r.value ?? "").trim() !== "");
  const importeLetra = {
    text: [
      { text: "Importe con letra:  ", style: "subheader" },
      { text: "( " + numeroALetra(dataSat.Total, dataSat.Moneda) + " )", style: "textoChico" },
    ],
    margin: [0, 0, 0, 8],
  };
  const cierreIzquierda = {
    stack: [
      importeLetra,
      ...(bancosRows.length ? [PDFPaymentInfoV2({ titulo: "Datos bancarios", rows: bancosRows })] : []),
    ],
  };

  // --- Totales ---
  const totalsRows = [
    { label: "Subtotal:", value: dineroDisabledMask(quitarImpuestosFacturas ? dataSat.SubTotal + totalImpFL + agregarImpDesc : dataSat.SubTotal) },
    ...(((quitarImpuestosFacturas ? dataSat.Descuento + agregarImpDesc : dataSat.Descuento) > 0)
      ? [{ label: "Descuento:", value: "- " + dineroDisabledMask(quitarImpuestosFacturas ? dataSat.Descuento + agregarImpDesc : dataSat.Descuento) }]
      : []),
    ...(quitarImpuestosFacturas ? [] : impuestosTotales),
    { label: "TOTAL:", value: dineroDisabledMask(total), strong: true },
    ...retencionesTotales,
    ...(totalRetFL > 0 ? [{ label: "TOTAL PAGO:", value: dineroDisabledMask(dataSat.Total), strong: true }] : []),
  ];

  // --- Sección resumen (importe/bancos + totales). El QR fiscal va al pie. ---
  const seccionResumen = PDFSummarySectionV2({ left: cierreIzquierda, rows: totalsRows });

  const dd = {
    ...cancelado,
    content: [
      PDFHeaderV2({
        empresa,
        tituloPrincipal: "Factura",
        tituloFolio: "N° " + (dataSat.Serie ? dataSat.Serie : "F") + " - " + dataSat.Folio,
        regimenFiscal: true,
        tipoComprobante: "ingreso",
        meta: headerMeta,
      }),
      PDFClientInfoV2({ left: clienteLeft, right: clienteRight }),
      divisorV2(PDF_COLORS.neutralDivider, 6, 1),
      ...(impresionEspecial.length ? [...impresionEspecial, divisorV2(PDF_COLORS.neutralDivider, 6, 1)] : []),
      ...agregarEquipoMedico,
      PDFItemsTableV2({ title: buildTitle(), conceptos, widths: buildWidths() }),
      seccionResumen,
      PDFNotesV2(values.imprimirObservaciones && values.observaciones ? values.observaciones : null),
      ...advansLeyenda,
      ...leyendasFiscales,
      ...agregarCartaPorte,
      ...comercioExterior,
      ...tablaCfdiRelacionados,
      ...anadirPagare,
      PDFCfdiFooterV2({ dataExtra, dataSat, qrLink: linkqr }),
      PDFKioskoQRV2(idKiosko, "Escanee para ver su factura.", "center"),
      PDFTextoAdicionalV2(empresa.textoAdicional || null),
      ...(empresa?.camposFirmaVentas ? [BloqueFirmasPdf([{ titulo: "Entregó" }, { titulo: "Recibió" }])] : []),
    ],
    footer: PDFBrandFooterConNumeroV2(logoBiwo),
    images: {
      logo: empresa.logo.base64Completa,
    },
    styles: pdfStylesV2(empresa),
    defaultStyle: { font: MULISH_FONT },
    pageSize: "LETTER",
    pageMargins: PDF_PAGE_MARGINS,
  };

  function buildTitle() {
    return dataSat.Receptor.impresionEspecial
      ? [
        { text: "Line Item\nNumber:", style: "tituloTabla" },
        ...(cantidadJuntoPrecioUnitario ? [] : [{ text: "Cantidad\n(Order Qty):", style: "tituloTabla" }]),
        { text: "Unidad\n(Unit):", style: "tituloTabla" },
        { text: "Clave\nSAT:", style: "tituloTabla" },
        { text: "Descripción:", style: "tituloTabla", alignment: "left" },
        ...(cantidadJuntoPrecioUnitario ? [{ text: "Cantidad\n(Order Qty):", style: "tituloTabla" }] : []),
        { text: "P/U\n(Price Per Unit):", style: "tituloTabla", alignment: "left" },
        ...(precioUnitarioConDescuento ? [{ text: "P/U c/Desc.\n(Net Price):", style: "tituloTabla", alignment: "left" }] : []),
        ...(ocultarColumnaIVA ? [] : [{ text: "IVA:", style: "tituloTabla", alignment: "left" }]),
        { text: "IEPS:", style: "tituloTabla", alignment: "left" },
        { text: "Importe\n(Net Value):", style: "tituloTabla", alignment: "left" },
      ]
      : [
        { text: "", style: "tituloTabla" },
        ...(cantidadJuntoPrecioUnitario ? [] : [{ text: "Cant", style: "tituloTabla" }]),
        { text: "Unidad", style: "tituloTabla" },
        ...(mostrarClaveSAT ? [{ text: "Clave SAT", style: "tituloTabla" }] : []),
        ...(mostrarClave ? [{ text: "Clave", style: "tituloTabla" }] : []),
        { text: "Descripción", style: "tituloTabla" },
        ...(cantidadJuntoPrecioUnitario ? [{ text: "Cant", style: "tituloTabla" }] : []),
        { text: "P/U", style: "tituloTabla" },
        ...(precioUnitarioConDescuento ? [{ text: "P/U c/Desc.", style: "tituloTabla" }] : []),
        ...(quitarImpuestosFacturas ? [] : [
          ...(ocultarColumnaIVA ? [] : [{ text: "IVA", style: "tituloTabla" }]),
          ...(empresa.imprimirIEPS ? [{ text: "IEPS", style: "tituloTabla" }] : []),
        ]),
        { text: tituloImporte, style: "tituloTabla" },
      ];
  }

  function buildWidths() {
    return dataSat.Receptor.impresionEspecial
      ? [
        "8%",
        ...(cantidadJuntoPrecioUnitario ? [] : ["9%"]),
        "7%", "8%", `${26 + (ocultarColumnaIVA ? 7 : 0) - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`,
        ...(cantidadJuntoPrecioUnitario ? ["9%"] : []),
        "13%", ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []), ...(ocultarColumnaIVA ? [] : ["7%"]), "7%", "15%",
      ]
      : quitarImpuestosFacturas
        ? [
          "2%",
          ...(cantidadJuntoPrecioUnitario ? [] : [`${9 + widthExtraCantidad}%`]),
          `${9 + widthExtraUnidad}%`,
          ...(mostrarClaveSAT ? [`${widthClaveSAT}%`] : []),
          ...(mostrarClave ? [`${widthClave + widthExtraClave}%`] : []),
          //Se reparte el ancho de las columnas de IVA e IEPS que no se muestran
          `${29 + widthExtraDescripcionFinal + widthDevueltoClaves - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`,
          ...(cantidadJuntoPrecioUnitario ? [`${9 + widthExtraCantidad}%`] : []),
          "15%",
          ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []),
          "15%",
        ]
        : [
          "2%",
          ...(cantidadJuntoPrecioUnitario ? [] : [`${6 + widthExtraCantidad}%`]),
          `${7 + widthExtraUnidad}%`,
          ...(mostrarClaveSAT ? [`${widthClaveSAT}%`] : []),
          ...(mostrarClave ? [`${widthClave + widthExtraClave}%`] : []),
          `${25 + widthExtraDescripcionFinal - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`,
          ...(cantidadJuntoPrecioUnitario ? [`${6 + widthExtraCantidad}%`] : []),
          "10.5%",
          ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []),
          ...(ocultarColumnaIVA ? [] : ["9%"]),
          ...(empresa.imprimirIEPS ? [`${widthIEPS}%`] : []),
          "12.5%",
        ];
  }

  return dd;
};

export default facturaPdfV2;
